module.exports = __webpack_public_path__ + "img/recycle.a6b46aab.svg";